import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { checkAuth } from '~/@api/client/useApiClientUser'
import { handleFallbackCookieAuth } from '~/@api/client/cookieAuthFallbacks'
import { useAuthStore } from '~/@api/client/authStore'
import { useIdentityVerificationStatus } from './useIdentityVerificationStatus'
import { Spinner } from '~/shadcn/ui/spinner'

function VeriffRedirectPage() {
  const navigate = useNavigate()
  const { setIdentitySubmittedStatus } = useIdentityVerificationStatus()

  useEffect(() => {
    async function handleVeriffRedirect() {
      let isAuthenticated = await checkAuth()

      if (!isAuthenticated) {
        handleFallbackCookieAuth()
        isAuthenticated = useAuthStore.getState().auth != null
      }

      if (!isAuthenticated) {
        navigate('/login', { replace: true })
        return
      }

      try {
        await setIdentitySubmittedStatus()
      } catch {
        // Backend webhook may already have updated status; continue redirect.
      }

      navigate('/get-started/identity-verification', { replace: true })
    }

    void handleVeriffRedirect()
  }, [navigate, setIdentitySubmittedStatus])

  return (
    <div className="flex min-h-[50vh] items-center justify-center">
      <Spinner className="size-8" />
    </div>
  )
}

export default VeriffRedirectPage
